import './component/sellops-color-picker';
import './acl/privileges';
import './module/sellops-upsell';

import SellopsUpsellApiService from './service/sellops-upsell.api.service';

Shopware.Application.addServiceProvider('sellopsUpsellApiService', (container) => {
    const initContainer = Shopware.Application.getContainer('init');

    return new SellopsUpsellApiService(initContainer.httpClient, container.loginService);
});
